import { Component, inject, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModalModule, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CustomModal } from '../../shared/services/ziro-modal.service';
import { Observable } from 'rxjs';

export interface FileUploadProgressModalViewProperties {
  fileUploadProgress: Observable<number>;
  message: string;
}

@Component({
  selector: 'ziro-file-upload-progress-modal',
  templateUrl: './file-upload-progress-modal.component.html',
  imports: [CommonModule, TranslateModule, NgbModalModule, NgbProgressbarModule],
})
export class FileUploadProgressModalComponent implements CustomModal<FileUploadProgressModalViewProperties>, OnInit {
  modalProperties: FileUploadProgressModalViewProperties;

  private _ngbActiveModal = inject(NgbActiveModal);

  ngOnInit(): void {
    this.modalProperties.fileUploadProgress.subscribe({
      complete: () => {
        this._ngbActiveModal.close();
      },
    });
  }
}
